import { theme } from '@lmc/ui-kit'

const PaywallIcon = () => {
  return (
    <svg
      width="152"
      height="165"
      viewBox="0 0 152 165"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M152 48.1184V116.963C151.813 117.125 151.697 117.35 151.677 117.592C151.137 120.426 149.958 123.108 148.225 125.444C146.491 127.783 144.247 129.718 141.651 131.11L86.029 162.231C82.963 164.093 79.409 165.053 75.7944 164.998C72.18 164.942 68.6592 163.873 65.6555 161.917L10.0328 130.796C6.92403 129.128 4.3454 126.664 2.57774 123.671C0.81008 120.677 -0.0788375 117.27 0.00779126 113.82V51.5763C-0.094746 48.0015 0.816487 44.4682 2.64173 41.3631C4.46698 38.2582 7.13585 35.7012 10.3562 33.9721L65.6555 2.85041C68.7667 0.986825 72.3495 0 76.0039 0C79.6584 0 83.241 0.986825 86.3523 2.85041L141.976 34.2865C146.092 36.4415 149.215 40.0375 150.707 44.346C151.283 45.5519 151.716 46.8175 152 48.1184Z"
        fill={theme.color.neutral.color11}
      />
      <path
        d="M76.3204 139.999C64.9098 140.062 53.7372 136.744 44.2186 130.465C34.7 124.186 27.2639 115.228 22.853 104.727C18.4421 94.226 17.255 82.6547 19.4419 71.4796C21.6289 60.3047 27.0916 50.0291 35.1376 41.9554C43.1836 33.8817 53.4507 28.3733 64.6375 26.1286C75.8244 23.8838 87.4272 25.0035 97.9755 29.346C108.524 33.6885 117.543 41.058 123.889 50.5207C130.236 59.9834 133.623 71.113 133.623 82.4992C133.708 90.0468 132.287 97.5359 129.443 104.53C126.597 111.523 122.384 117.882 117.05 123.234C111.716 128.586 105.368 132.826 98.3749 135.703C91.382 138.582 83.8848 140.042 76.3204 139.999Z"
        fill={theme.color.status.popout}
      />
      <g clipPath="url(#clip0_7576_199278)">
        <path
          d="M65 66C65 59.925 69.925 55 76 55C82.075 55 87 59.925 87 66V74H89V66C89 58.82 83.18 53 76 53C68.82 53 63 58.82 63 66V74H65V66Z"
          fill={theme.color.neutral.color11}
        />
        <path
          d="M97.5 76H54.5C52.567 76 51 77.567 51 79.5V108.5C51 110.433 52.567 112 54.5 112H97.5C99.433 112 101 110.433 101 108.5V79.5C101 77.567 99.433 76 97.5 76ZM81.916 91.994C81.49 94.512 79.518 96.484 77 96.91V103C77 103.552 76.552 104 76 104C75.448 104 75 103.552 75 103V96.91C71.733 96.358 69.532 93.261 70.084 89.994C70.636 86.727 73.733 84.526 77 85.078C80.267 85.63 82.468 88.727 81.916 91.994Z"
          fill={theme.color.neutral.color11}
        />
      </g>
      <defs>
        <clipPath id="clip0_7576_199278">
          <rect
            width="50"
            height="59"
            fill={theme.color.neutral.color11}
            transform="translate(51 53)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default PaywallIcon
